/* ==========================================================================
   TCX — Trading Card Landing Page behaviour
   Loaded by several sections; self-guarded so duplicate <script> tags and
   theme-editor section reloads never double-bind.
   Handles: scroll reveal + the two-axis product chooser (tier x footprint).
   ========================================================================== */
(function () {
  'use strict';
  if (window.__tcxLanding) { window.__tcxLanding.refresh(); return; }

  /* ---------- scroll reveal ---------- */
  var io = null;
  function reveal(scope) {
    var els = (scope || document).querySelectorAll('.tcx-rv:not(.tcx-in)');
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('tcx-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e, i) {
          if (!e.isIntersecting) return;
          e.target.style.transitionDelay = Math.min(i, 6) * 90 + 'ms';
          e.target.classList.add('tcx-in');
          io.unobserve(e.target);
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    }
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  /* ---------- product chooser ---------- */
  function initChooser(root) {
    if (!root || root.__tcxBound) return;
    root.__tcxBound = true;

    var grid   = root.querySelector('[data-tcx-grid]');
    var cards  = Array.prototype.slice.call(root.querySelectorAll('[data-tcx-card]'));
    var empty  = root.querySelector('[data-tcx-empty]');
    var count  = root.querySelector('[data-tcx-count]');
    var noteT  = root.querySelector('[data-tcx-note-title]');
    var noteB  = root.querySelector('[data-tcx-note-body]');
    if (!grid) return;

    var state = { tier: 'all', size: 'all' };

    function apply() {
      var shown = 0;
      cards.forEach(function (card, i) {
        var okTier = state.tier === 'all' || card.getAttribute('data-tier') === state.tier;
        var okSize = state.size === 'all' || card.getAttribute('data-size') === state.size;
        var match  = okTier && okSize;
        card.hidden = !match;
        if (match) {
          shown++;
          card.style.animation = 'none';
          void card.offsetWidth;                                  // force reflow -> replay
          card.style.animation = 'tcx-pop .42s cubic-bezier(.2,.7,.3,1) ' + (Math.min(i, 8) * 0.035) + 's both';
        }
      });
      if (empty) empty.hidden = shown !== 0;
      if (count) count.textContent = shown;

      // helper copy comes from the active tier button, falling back to the size button
      var src = root.querySelector('[data-tcx-filter="tier"][aria-pressed="true"]');
      if (state.tier === 'all' && state.size !== 'all') {
        src = root.querySelector('[data-tcx-filter="size"][aria-pressed="true"]') || src;
      }
      if (src) {
        if (noteT && src.getAttribute('data-note-title')) noteT.textContent = src.getAttribute('data-note-title');
        if (noteB && src.getAttribute('data-note-body'))  noteB.textContent = src.getAttribute('data-note-body');
      }
    }

    root.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-tcx-filter]');
      if (!btn || !root.contains(btn)) return;
      var axis = btn.getAttribute('data-tcx-filter');          // 'tier' | 'size'
      root.querySelectorAll('[data-tcx-filter="' + axis + '"]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b === btn));
      });
      state[axis] = btn.getAttribute('data-value');
      apply();
    });

    apply();
  }

  function refresh(scope) {
    reveal(scope);
    var roots = (scope || document).querySelectorAll('[data-tcx-chooser]');
    Array.prototype.forEach.call(roots, initChooser);
  }

  window.__tcxLanding = { refresh: refresh };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refresh(); });
  } else {
    refresh();
  }

  /* theme editor: sections are re-rendered without a page reload */
  document.addEventListener('shopify:section:load', function (e) { refresh(e.target); });
})();
